import { Colors, regExp } from '@sigma-frontend-libs/commons'

import { billingsSources, buttonModes, components, labelModes, services } from '@/utils'

import button from '@/components/button'
import generatorRow from '@/components/generator/row'
import footer from '@/components/services/settings/fields/footer'
import header from '@/components/services/settings/fields/header'

function renderHeader(h, options) {
  return h(
    header,
    {
      props: {
        options,
        label: this.label
      }
    }
  )
}

function renderSourceButton(h, options, item) {
  return h(
    button,
    {
      props: {
        iconSVG: item.source,
        mode: buttonModes.flat,
        color: Colors[item.source],
        tooltip: this.getTranslate(`${services.billings}.sources.${item.source}`),
        disabled: options.permission === 'read'
      },
      on: {
        click: () => {
          switch (item.source) {
            case billingsSources.accrual: {
              item.source = billingsSources.subtract
              break
            }
            case billingsSources.subtract: {
              item.source = billingsSources.accrual
              break
            }
          }
        }
      }
    }
  )
}
function renderPercentField(h, options, item) {
  return h(
    components['text-field'],
    {
      props: {
        value: item.percent,
        hint: this.getTranslate(`${options.serviceName}.hints.${options.path}.percent`),
        suffix: '%',
        mask: regExp.positiveNumberFourSymbolsAfterDot,
        labelMode: labelModes.hidden,
        readonly: options.permission === 'read',
        dense: true,
        details: true
      },
      on: {
        input: event => {
          if (typeof event === 'string') {
            item.percent = event.replace(',', '.')
          } else {
            item.percent = event
          }
        }
      }
    }
  )
}
function renderMinimumField(h, options, item) {
  const currency = options?.payload?.settings?.['billings.currency']

  return h(
    components['text-field'],
    {
      props: {
        value: item.limitMin,
        hint: this.getTranslate(`${options.serviceName}.hints.${options.path}.limitMin`),
        suffix: this.getTranslate(`currency.${currency}.symbol.unicode`),
        mask: regExp.integer,
        labelMode: labelModes.hidden,
        readonly: options.permission === 'read',
        dense: true,
        details: true
      },
      on: {
        input: event => {
          item.limitMin = event
        }
      }
    }
  )
}
function renderMaximumField(h, options, item) {
  const currency = options?.payload?.settings?.['billings.currency']

  return h(
    components['text-field'],
    {
      props: {
        value: item.limitMax,
        hint: this.getTranslate(`${options.serviceName}.hints.${options.path}.limitMax`),
        suffix: this.getTranslate(`currency.${currency}.symbol.unicode`),
        mask: regExp.integer,
        labelMode: labelModes.hidden,
        readonly: options.permission === 'read',
        dense: true,
        details: true
      },
      on: {
        input: event => {
          item.limitMax = event
        }
      }
    }
  )
}
function renderItemFields(h, options, item) {
  return h(
    'div',
    {
      class: 'settings-fields__item-fields'
    },
    [
      renderPercentField.call(this, h, options, item),
      renderMinimumField.call(this, h, options, item),
      renderMaximumField.call(this, h, options, item)
    ]
  )
}
function renderItem(h, options, item) {
  return h(
    'div',
    {
      class: 'settings-fields__item'
    },
    [
      renderSourceButton.call(this, h, options, item),
      renderItemFields.call(this, h, options, item)
    ]
  )
}
function renderBody(h, options) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy,
        defaultValue: {
          source: billingsSources.accrual,
          percent: 0,
          limitMin: 0,
          limitMax: 0
        },
        addDisabled: this.addDisabled,
        max: Object.values(billingsSources).length,
        readonly: options.permission === 'read',
        gap: 4
      },
      scopedSlots: {
        row: ({ item }) => {
          return renderItem.call(this, h, options, item)
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderFooter(h, options) {
  return h(
    footer,
    {
      props: {
        options,
        label: this.label,
        description: this.getTranslate(`${options.serviceName}.descriptions.${options.path}`),
        disabled: this.disabled,
        showDescription: true
      },
      on: {
        input: () => {
          this.transmitValue()
        }
      }
    }
  )
}

export default function(h, options) {
  if (options.permission !== false) {
    return h(
      'div',
      {
        class: 'settings-fields'
      },
      [
        renderHeader.call(this, h, options),
        renderBody.call(this, h, options),
        renderFooter.call(this, h, options)
      ]
    )
  }
}
